import { Injectable } from '@angular/core';
import { Event } from './../../models/calendar/event';

@Injectable()
export class StylesProvider {

  getDefeatedIconClass(endDefeatDate: number): string {

    if (endDefeatDate && !this.isExpiredDate(endDefeatDate)) {

      return 'fa-check-circle text-success';
    }

    if (endDefeatDate && this.isExpiredDate(endDefeatDate)) {

      return 'fa-times-circle text-hot';
    }

    return 'fa-check-circle text-hint';
  }

  getLeadClosestEventIconClass(event: Event): string {

    let cssClass = '';

    if (event.type === 'reminder') {
      cssClass += 'fa-clock';
    } else if (event.type === 'visit') {
      cssClass += 'fa-map-marked-alt';
    } else {
      cssClass += 'fa-map-marked-alt';
    }

    if (event.dateFrom && !this.isExpiredDate(event.dateFrom)) {
      cssClass += ' text-success';
    } else if (event.dateFrom && this.isExpiredDate(event.dateFrom)) {
      cssClass += ' text-hot';
    } else {
      cssClass += ' text-hint';
    }

    return cssClass;
  }

  private isExpiredDate(dateToCheck: number | string): boolean {
    return Date.now() > dateToCheck;
  }

  getClassWhiteBrand() {
    const hostname = window.location.hostname;
    if (hostname.indexOf('kia') !== -1) {
      return 'kia';
    }
    if (hostname.indexOf('niw') !== -1) {
      return 'niw';
    }
    if (hostname.indexOf('carwow') !== -1) {
      return 'carwow';
    }

    if (hostname.indexOf('carnovo') !== -1) {
      return 'carnovo';
    }

    if (hostname.indexOf('autonext') !== -1) {
      return 'autonext';
    }
    // DONT TOUCH THIS LINE, HERE REPLACE AUTO
  }

}
